import axios from "axios";
import groups from "../../models/grupos/groups";
import moment from "moment";
import groupsGt from "../../models/gestionTiempos/groups/groups";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getGroups() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/grpgrp`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return groups.fromJson(item);
        });
      });
  }
  getSubGroups() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const operId = localStorage.getItem("operId");
    const fecha = moment().format("YYYY-MM-DD");

    return axios
      .get(`${url}/grupos/${operId}&${fecha}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return groupsGt.fromJson(item);
        });
      });
  }

  new(items) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
   
    let payload = {
      nombre: items.group,
    };
    return axios.post(`${url}/grupos`, payload, { headers });
  }
  newSubGroup(items) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
   
    let payload = {
      grupoParentId: items.idParent,
      grupos: items.groups,
    };

    return axios.post(`${url}/grpgrp`, payload, { headers });
  }

  edit(data) {
    
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.name,
      grupoPadreId: data.grupoPadreId === null ? undefined : data.father,
    };
    const query =`grupopadreid=${data.oldFather}`
    if(data.oldFather){
      return axios
      .patch(`${url}/grupos/${data.id}?${query}`, payload, { headers })
      .then(() => {});
    }else{
      return axios
      .patch(`${url}/grupos/${data.id}`, payload, { headers })
      .then(() => {});
    }
    
  }

  delete(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    
   if(data.hasFather){
    return axios.delete(`${url}/grpgrp/${data.father}&${data.id}`, { headers });
   }else{
    return axios.delete(`${url}/grupos/${data.id}`, { headers });
   }
   
  }
}
export default service;
